import RaporTeacher from "../../../../../components/categories/siakad/laporan_adab/rapor/HomeTeacher"
export default function Home() {
  
  return (
    <RaporTeacher />
  );
}
